'use client'

import Image from 'next/image'
import Link from 'next/link'
import { StoreAnalytics, trackStoreEvent } from '@nile/mantine-theme/analytics'
import { siteRoutes } from '@/lib/routes/site'
import classes from './Logo.module.css'
import { appPath } from '@/lib/getPublicAppUrl'

/**
 * Home lockup: wordmark from 768px up, cross at 767px and below.
 * Always links to `/`.
 */
export function Logo() {
    return (
        <Link
            href={siteRoutes.home}
            prefetch
            aria-label="General Medicine home"
            className={classes.logoLink}
            onClick={() => trackStoreEvent(StoreAnalytics.NAV_HEADER_CLICKED, { name: 'logo' })}
            data-dd-privacy="allow"
            data-testid="site-logo"
        >
            <Image
                className={classes.desktopLogo}
                src={appPath('/site-header-desktop-logo.svg')}
                alt="General Medicine"
                width={156}
                height={28}
                priority
                data-dd-privacy="allow"
            />
            <Image
                className={classes.mobileLogo}
                src={appPath('/site-header-mobile-logo.svg')}
                alt="General Medicine"
                width={44}
                height={44}
                priority
                data-dd-privacy="allow"
            />
        </Link>
    )
}
